import CoreBase from '../../services/engines/CoreBase';
import CalEventObj from './CalEventObj';
import { CalEventStates } from './CalEventStates';
import moment from 'moment-timezone';
import userSettingsEngine from '../../controllers/UserSettings/UserSettingsEngine';

/**
 * CalEventFactory — builds CalEventObj instances that need more than straight
 * field assignment, e.g. a brand new event with sensible defaults.
 * Singleton — stateless, but consistent with the rest of the codebase
 * (CalendarCache/CalendarScheduler, CalendarEngine.Sessions rk=3aa2cd62).
 */
class CalEventFactory extends CoreBase {
    /**
     * Creates a CalEventObj for a brand new event — date/time default to now + 10
     * minutes so the reminder picker opens with a sensible upcoming moment.
     * remind defaults to '30m' (see ReminderOffset.REMINDER_PRESETS).
     * @returns {CalEventObj}
     */
    createNew = () => {
        const { date, time } = this.defaultDateTime();

        return new CalEventObj({
            rk: '',
            label: '',
            desc: null,

            date,
            time,

            cat: '',
            remind: '30m',
            ems: 0,
            createdOn: 0,
            stateId: CalEventStates.Active,
            app: '',
            posX: 0,
            posY: 0,
            height: 0,
            width: 0,
        });
    };

    // ─── private ──────────────────────────────────────────

    /**
     * Returns { date: YYYY-MM-DD, time: HH:MM } for "now + 10 minutes", in
     * the user's configured timeZone setting (userSettingsEngine.resolve
     * ('timeZone'), IANA zone, default Europe/Amsterdam) — not browser/OS-local.
     * Symmetric with CalEventObj._deriveEms(), which converts date/time back
     * to ems in the same zone.
     * @returns {{ date: string, time: string }}
     */
    defaultDateTime = () => {
        const tz = userSettingsEngine.resolve('timeZone');
        const m = moment.tz(Date.now() + 10 * 60 * 1000, tz);
        return { date: m.format('YYYY-MM-DD'), time: m.format('HH:mm') };
    };
}

const calEventFactory = new CalEventFactory();
export default calEventFactory;
